<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BILrVe/tc-custom/9780253037749.jpg?1737057939500" alt="This image is the cover for the book Memory, Politics, and Yugoslav Migrations to Postwar Germany"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Memory, Politics, and Yugoslav Migrations to Postwar Germany
      </h1>
      <p class="bookDescription body article font2">
        <b>This historical study “persuasively links the reception of Yugoslav migrants to West Germany’s shifting relationship to the Nazi past . . . essential reading” (Tara Zahra, author of <i>The Great Departure</i>). </b><br/><br/> During Europe’s 2015 refugee crisis, more than a hundred thousand asylum seekers from the western Balkans sought refuge in Germany. This was nothing new, however. Immigrants from the Balkans have streamed into West Germany in massive numbers since the end of the Second World War. In fact, Yugoslavs became the country’s second largest immigrant group. Yet their impact has received little critical attention until now.<br/><br/> Memory, Politics, and Yugoslav Migrations to Postwar Germany tells the story of how Germans received the many thousands of Yugoslavs who migrated to Germany as political emigres, labor migrants, asylum seekers, and war refugees from 1945 to the mid-1990s. With a particular focus on German policies and attitudes toward immigrants, Christopher Molnar argues that considerations of race played only a marginal role in German attitudes and policies towards Yugoslavs. Rather, the history of Yugoslavs in postwar Germany was most profoundly shaped by the memory of World War II and the shifting Cold War context. Molnar shows how immigration was a central aspect of how Germany negotiated the meaning and legacy of the war.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher A. Molnar
      </h2>
      
      <p class="authorDescription body article"><P>Christopher A. Molnar is Assistant Professor of History at the University of Michigan-Flint.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2777ec14